// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import iView from 'iview'
import Viewer   from 'v-viewer'
import VueLazeLoad from 'vue-lazyload'

import {baseUrl} from './config' 
import {baseImg} from './config' 

import '@/my-theme/index.less';
import 'viewerjs/dist/viewer.css'
import './assets/fonts/iconfont.css'

Vue.config.productionTip = true;
Vue.prototype.$url = baseUrl;
Vue.prototype.$urls = baseImg;

 

Vue.use(iView);
Vue.use(Viewer);
Vue.use(VueLazeLoad, {
  preLoad: 1.3,
  error: require('./assets/img/err.png'),
  loading: require('./assets/img/loading.gif'),
  attempt: 1,
  listenEvents: ['scroll']
})
/* eslint-disable no-new */   
new Vue({
  el: '#app', 
  router,
  store, 
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js